import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
	FreudButtonModule,
	FreudDialogModule,
	FreudLoaderModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { ConflictInviteNewAppointmentModal } from './conflict-invite-new-appointment-modal.component';

@NgModule({
	declarations: [ConflictInviteNewAppointmentModal],
	imports: [
		CommonModule,
		TranslateModule.forChild(),
		FreudButtonModule,
		FreudDialogModule,
		FreudLoaderModule,
	],
	exports: [ConflictInviteNewAppointmentModal],
	providers: [],
})
export class ConflictInviteNewAppointmentModalModule {}
